import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

const Auth2Service = ({ children }) => {
  const navigate = useNavigate();

  const domain = "dev-ktwv3i3mxofd0jgv.us.auth0.com";
  const clientId = "tcagBfX4Go83eonHFkeXpfimKCZWVyVg";

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: "https://dev.hypersocio.com"
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth2Service;
